import { render, staticRenderFns } from "./ImportCorrigendumDialog.vue?vue&type=template&id=5dc970d8"
import script from "./ImportCorrigendumDialog.vue?vue&type=script&lang=js"
export * from "./ImportCorrigendumDialog.vue?vue&type=script&lang=js"
import style0 from "./ImportCorrigendumDialog.vue?vue&type=style&index=0&id=5dc970d8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports